import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';

import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class MaterialsRevisoesAcoes extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',        
      },
      redirect_url: false,
      material_revision_id: this.props.material_revision_id,
      status: this.props.status,
      material_id: this.props.material_id,
      class_edit: '',
      class_status: '',
      alt_status: '',
      title_status: '',
    };
    //bind geral
    // handleChange e handleChangeSelect necessitam do bind nas tags
    this.trocarStatus = this.trocarStatus.bind(this);
    this.adicionarRevisao = this.adicionarRevisao.bind(this);
    this.adicionarArquivo = this.adicionarArquivo.bind(this);
  }

  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {
    if(typeof newProps.status !== 'undefined') {
      this.setState({
        status: newProps.status,
      });
    }
    if(Array.isArray(newProps.material_revision_id)) {
      this.setState({material_revision_id: newProps.material_revision_id});
    }
    if(Array.isArray(newProps.material_id)) {
      this.setState({material_id: newProps.material_id});
    }
  }

  trocarStatus () {
    var toggle = this.state.status;
    if (toggle === 'aberta') {
      toggle = 'aprovada';
    }
    var datasave = {
      id: this.state.material_revision_id,
      material_id: this.state.material_id,
      status: toggle,
    };
    var confirmacao = window.confirm('Tem certeza que deseja mudar o status dessa revisão?');
    if(confirmacao) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/material/revisao/change_status', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.refreshTable(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });      
    }
  }

  adicionarRevisao(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var datasave = {
      material_id: this.props.material_id,
      material_revision_id: this.props.material_revision_id,
      status: this.props.status,
    };
    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/material/revisao', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        self.props.refreshTable(responseJson);
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  adicionarArquivo(event) {
    event.preventDefault();
    this.props.handleAlert('', '', 'open');
    var data = new FormData();
    var imagedata = document.querySelector('input[type="file"]').files[0];
    data.append("imagem", imagedata);
    data.append("material_revision_id", this.props.material_revision_id);
    var header = this.refs.request_api.header();
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/material/arquivo', {
        method: 'POST',
        mode: 'cors',
        headers: value,
        body: data }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.refreshTable(responseJson);
        }).catch((error) => {
        console.error(error);
      });
    });   
  }

  render() {
    if (this.state.status == "aberta") {
    return (
<div>
  <RequestApi ref={'request_api'} />
  <div className="row">
    <div className="col-md-4">
      <button onClick={this.trocarStatus} className='btn btn-sm btn-block btn-primary' alt='Trocar para aprovada' title='Trocar para aprovada'><i className="fa fa-fw fa-certificate"></i>Aprovar revisão</button>
    </div>
    <div className="col-md-8">
      <form onSubmit={this.adicionarArquivo}> 
        <div className="row">
          <div className="col-md-6">
            <div className="">
              <input type="text" type="file" name="archive" className="form-control" placeholder="Nome do arquivo" value={this.state.archive} onChange={this.handleChange.bind(this, 'archive')} />
            </div>
          </div>
          <div className="col-md-6">
            <div className="">
              <button type="submit" className="btn btn-primary btn-sm btn-block"><i className="fa fa-plus"></i> Adicionar arquivo</button>
            </div>
          </div>
        </div>
      </form> 
    </div>
  </div>
</div>
      );
    } else if (this.state.status == "aprovada") {
      return (
    <div>
      <RequestApi ref={'request_api'} />
      <button onClick={this.adicionarRevisao} className='btn btn-sm btn-info' alt='Criar Revisão' title='Criar Revisão'><i className="fa fa-fw fa-refresh"></i>Criar revisão</button>
    </div>
          );
    } else {
      return (
    <div>
      <RequestApi ref={'request_api'} />
    </div>
        );
    }
  }
}

export default MaterialsRevisoesAcoes;



// WEBPACK FOOTER //
// ./src/Components/Materials/Elements/MaterialsRevisoesAcoes.js